import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_2 = { class: "flex items-center justify-between" }

import { onMounted, ref, computed, watch } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import FormSection from "./FormSection.vue";
import PatientService from "@/classes/PatientService";
import { EditPatient } from "@/interfaces/PatientInterface";
import { useRouter, useRoute } from "vue-router";
import { renderSelectV2, renderSelect } from "@/interfaces/DropdownInterface";
import { errorResponse } from "@/helpers/errorMessage";
import PageLoader from "@/components/loaders/PageLoader.vue";
import { useNetworkStore } from "@/store/network";
import pickBy from "lodash/pickBy";
import { onIonViewWillEnter } from "@ionic/vue";
import CaseHistoryService from "@/classes/Cases/CaseHistory/CaseHistoryService";
import PatientOfflineForm from "@/classes/Patients/Offline/Formatters/PatientOfflineForm";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const router = useRouter();
const route = useRoute();
const patientId = ref<number | null>(route.params.patient);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully updated!");
const sexAtBirthOptions = ref<renderSelectV2[]>([]);
const religionOptions = ref<renderSelect[]>([]);
const civilStatusOptions = ref<renderSelect[]>([]);
const nationalityOptions = ref<renderSelect[]>([]);
const form = ref<EditPatient>(PatientOfflineForm.createPatientCaseForm());
const errors = ref<object>({});
const loaded = ref<boolean>(false);
const loading = ref<boolean>(false);
const indigeneousOptions = ref<renderSelect[]>([]);
const offlineParams = ref<string>(route.query.offline);

const save = (): void => {
	loading.value = true;
    errors.value = {};

	if (!isNetworkAvailable.value) {
		const validate = form.value.offlineUpdateValidation(form.value);
		errors.value = validate?.errors;

		if (validate.hasOfflineError) {
			showSuccess.value = false;
			return;
		}
	}

	PatientService.update(
		patientId.value,
		{ ...form.value, ...{ isOfflineData: offlineParams.value } },
		isNetworkAvailable.value
	)
		.then((response: object) => {
			showSuccess.value = true;
			successMessage.value = response.data.message;
			loading.value = false;
		})
		.catch((error: object) => {
			loading.value = false;
			errors.value = errorResponse(error.response?.data?.errors);
		});
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
    router.push(`/patient/${patientId.value}/view`);
};

const getData = async (): Promise<any> => {
	loading.value = true;

    const response = await CaseHistoryService.create(patientId.value, pickBy({}), isNetworkAvailable.value)

    if (response?.response?.status === 404) {
        loading.value = false;
        return;
    }
    
    if (response?.status === 200 || response?.data != undefined) {
        form.value = {
            ...form.value,
            ...PatientOfflineForm.fillPatientForm(response.data.item)
        };
        sexAtBirthOptions.value = response.data.sexAtBirth;
        civilStatusOptions.value = response.data.civilStatuses;
        indigeneousOptions.value = response.data.indigeneous;

        loaded.value = true;
        loading.value = false;
    } else {
        const error = response;
        loading.value = false;
        console.log(error);
    }
};

watch(
	() => isNetworkAvailable.value,
	async (val) => {
		await getData();
	}
);

onIonViewWillEnter(async () => await getData());
// onMounted(async () => await getData());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/view`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, { title: "Patient Profile Details" })
        ]),
        (loaded.value)
          ? (_openBlock(), _createBlock(FormSection, {
              key: 0,
              form: form.value,
              disabled: true,
              "sex-at-birth": sexAtBirthOptions.value,
              "civil-statuses": civilStatusOptions.value,
              nationalities: nationalityOptions.value,
              religions: religionOptions.value,
              indigeneous: indigeneousOptions.value,
              errors: errors.value
            }, null, 8, ["form", "sex-at-birth", "civil-statuses", "nationalities", "religions", "indigeneous", "errors"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[0] || (_cache[0] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Record Save!",
        content: successMessage.value
      }, null, 8, ["show", "content"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})